import { c as create_ssr_component, d as add_attribute, e as escape, v as validate_component } from "../../../../chunks/ssr.js";
import { B as BookOpenPageVariant, S as ServicePageTemplate } from "../../../../chunks/ServicePageTemplate.js";
import { B as Button } from "../../../../chunks/Button.js";
import { C as CopyCard } from "../../../../chunks/CopyCard.js";
import { C as CastEducation } from "../../../../chunks/CastEducation.js";
import { T as Turbine } from "../../../../chunks/Turbine.js";
const Update = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { size = "1em" } = $$props;
  let { width = size } = $$props;
  let { height = size } = $$props;
  let { color = "currentColor" } = $$props;
  let { viewBox = "0 0 24 24" } = $$props;
  let { ariaLabel = void 0 } = $$props;
  let { ariaHidden = void 0 } = $$props;
  let { title = void 0 } = $$props;
  let { desc = void 0 } = $$props;
  let { class: className = void 0 } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0)
    $$bindings.size(size);
  if ($$props.width === void 0 && $$bindings.width && width !== void 0)
    $$bindings.width(width);
  if ($$props.height === void 0 && $$bindings.height && height !== void 0)
    $$bindings.height(height);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0)
    $$bindings.color(color);
  if ($$props.viewBox === void 0 && $$bindings.viewBox && viewBox !== void 0)
    $$bindings.viewBox(viewBox);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0)
    $$bindings.ariaLabel(ariaLabel);
  if ($$props.ariaHidden === void 0 && $$bindings.ariaHidden && ariaHidden !== void 0)
    $$bindings.ariaHidden(ariaHidden);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0)
    $$bindings.title(title);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0)
    $$bindings.desc(desc);
  if ($$props.class === void 0 && $$bindings.class && className !== void 0)
    $$bindings.class(className);
  return `<svg${add_attribute("viewBox", viewBox, 0)}${add_attribute("width", width, 0)}${add_attribute("height", height, 0)}${add_attribute("class", className, 0)}${add_attribute("aria-label", ariaLabel, 0)}${add_attribute("aria-hidden", ariaHidden, 0)}>${desc ? `<desc>${escape(desc)}</desc>` : ``}${title ? `<title>${escape(title)}</title>` : ``}<path d="M21,10.12H14.22L16.96,7.3C14.23,4.6 9.81,4.5 7.08,7.2C4.35,9.91 4.35,14.28 7.08,17C9.81,19.7 14.23,19.7 16.96,17C18.32,15.65 19,14.08 19,12.1H21C21,14.08 20.12,16.65 18.36,18.39C14.85,21.87 9.15,21.87 5.64,18.39C2.14,14.92 2.11,9.28 5.62,5.81C9.13,2.34 14.76,2.34 18.27,5.81L21,3V10.12M12.5,8V12.25L16,14.33L15.28,15.54L11,13V8H12.5Z"${add_attribute("fill", color, 0)}></path></svg>`;
});
const CardAccountDetails = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { size = "1em" } = $$props;
  let { width = size } = $$props;
  let { height = size } = $$props;
  let { color = "currentColor" } = $$props;
  let { viewBox = "0 0 24 24" } = $$props;
  let { ariaLabel = void 0 } = $$props;
  let { ariaHidden = void 0 } = $$props;
  let { title = void 0 } = $$props;
  let { desc = void 0 } = $$props;
  let { class: className = void 0 } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0)
    $$bindings.size(size);
  if ($$props.width === void 0 && $$bindings.width && width !== void 0)
    $$bindings.width(width);
  if ($$props.height === void 0 && $$bindings.height && height !== void 0)
    $$bindings.height(height);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0)
    $$bindings.color(color);
  if ($$props.viewBox === void 0 && $$bindings.viewBox && viewBox !== void 0)
    $$bindings.viewBox(viewBox);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0)
    $$bindings.ariaLabel(ariaLabel);
  if ($$props.ariaHidden === void 0 && $$bindings.ariaHidden && ariaHidden !== void 0)
    $$bindings.ariaHidden(ariaHidden);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0)
    $$bindings.title(title);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0)
    $$bindings.desc(desc);
  if ($$props.class === void 0 && $$bindings.class && className !== void 0)
    $$bindings.class(className);
  return `<svg${add_attribute("viewBox", viewBox, 0)}${add_attribute("width", width, 0)}${add_attribute("height", height, 0)}${add_attribute("class", className, 0)}${add_attribute("aria-label", ariaLabel, 0)}${add_attribute("aria-hidden", ariaHidden, 0)}>${desc ? `<desc>${escape(desc)}</desc>` : ``}${title ? `<title>${escape(title)}</title>` : ``}<path d="M2,3H22C23.05,3 24,3.95 24,5V19C24,20.05 23.05,21 22,21H2C0.95,21 0,20.05 0,19V5C0,3.95 0.95,3 2,3M14,6V7H22V6H14M14,8V9H21.5L22,9V8H14M14,10V11H21V10H14M8,13.91C6,13.91 2,15 2,17V18H14V17C14,15 10,13.91 8,13.91M8,6A3,3 0 0,0 5,9A3,3 0 0,0 8,12A3,3 0 0,0 11,9A3,3 0 0,0 8,6Z"${add_attribute("fill", color, 0)}></path></svg>`;
});
const _page_svelte_svelte_type_style_lang = "";
const css = {
  code: '.sections_wrapper.svelte-304lf9{padding:50px 0;display:flex;flex-direction:column;align-items:center;gap:70px;overflow:hidden}@media(max-width: 800px){.sections_wrapper.svelte-304lf9{padding:50px 5px}}.flex-list.svelte-304lf9{display:flex;flex-wrap:wrap;gap:30px;justify-content:space-around;align-items:center;list-style-image:url("/svg/send.svg")}.button.svelte-304lf9{width:max-content}',
  map: null
};
let hero_image = "/boy.webp";
let h1 = "International Students";
let background_center = true;
let hero_paragraph_content = "International flight students coming to the US will be immersed to a completely new culture, new foods, people of many diverse backgrounds, and possibly driving on the “wrong” side of the road that you are used to! <br/><br/>Students at First Landings will also receive a comprehensive flight education focused on training them to become professional Airline Transport Pilots. <br/><br/>It makes no difference where you come from – be it North or South America, Europe, Asia, Africa, Pan Pacific, the only requirement is your desire to become a professional airline pilot.";
let center_img_seperating_section = false;
let programs = false;
let professionalProgram = false;
let pricingPackage = false;
let prerequisites = false;
let financing = false;
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let icon_size = "50%";
  let second_center_img_seperating_section = {
    src: "/multi_achieved.webp",
    alt: "Multi student checkride pass"
  };
  let roadmap_stages = [
    [
      {
        text: "Private Pilot",
        icon: BookOpenPageVariant
      },
      {
        text: "Instrument Certificate",
        icon: CastEducation
      },
      {
        text: "Commercial Single Engine",
        icon: BookOpenPageVariant
      },
      {
        text: "Commercial Multi Engine",
        icon: Turbine
      }
    ]
  ];
  $$result.css.add(css);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${$$result.head += `<!-- HEAD_svelte-it2tfg_START -->${$$result.title = `<title>International Students | First Landings Aviation</title>`, ""}<meta name="description" content="First Landings Aviation international student pilot training"><!-- HEAD_svelte-it2tfg_END -->`, ""} ${validate_component(ServicePageTemplate, "ServicePageTemplate").$$render(
      $$result,
      {
        hero_image,
        background_center,
        h1,
        financing,
        hero_paragraph_content,
        center_img_seperating_section,
        second_center_img_seperating_section,
        programs,
        professionalProgram,
        pricingPackage,
        prerequisites,
        roadmap_stages
      },
      {},
      {
        three: () => {
          return `<div slot="three" style="width: 100%;">${validate_component(CopyCard, "CopyCard").$$render($$result, {}, {}, {
            text: () => {
              return `<div slot="text"><ol data-svelte-h="svelte-y9r9kv"><li>Complete our <a href="/FLAP%20-%20OFA%20SEVIS%20Application%20Form.docx" style="color: #15181c;">Enrollment Application</a> and Checklist</li> <br> <li>E-mail your passport and government issued photo identification
            documents to <a href="mailto:info@firstlandings.com" style="color: #15181c;">info@firstlandings.com</a></li> <br> <li>Demonstrate that you have sufficient funds for your specified course
            (bank statement or equivalent)</li> <br> <li>First Landings will create your school account, allowing you to pay
            the enrollment fees, and then courier your student M1 Visa to your
            home address</li> <br> <li>Pay the <a href="https://www.ice.gov/sevis/i901" target="_blank" style="color: #15181c;">SEVIS I-901 Fee</a></li> <br> <li>Complete the <a href="https://ceac.state.gov/genniv/" target="_blank" style="color: #15181c;">online visa application form DS-160</a></li> <br> <li>Schedule your Interview Appointment with the US Embassy or Consulate</li> <br> <li>Make sure to bring the required interview documents (can differ
            depending on your country of origin)</li> <br> <li>Schedule and attend your US Embassy or Consulate interview</li> <br> <li>Provide your passport to the appropriate US Embassy or Consulate to
            obtain your M1 Visa</li> <br> <li>Complete your
            <a href="https://www.fts.tsa.dhs.gov/home" target="_blank" style="color: #15181c;">TSA FTSP application</a>, using course PPL, or INST, or COMM SEL, with Piper PA-28-181
            Pilot, or COMM MEL with Tecnam P2006t
            <br> <b>Note:</b> You will need to provide scanned copies of your various
            documents, and fingerprinting can be done in the US after your arrival</li> <br> <li>Schedule your expected arrival date with First Landings and confirm
            with us once you are in the US</li></ol> <br> <div class="button svelte-304lf9">${validate_component(Button, "Button").$$render(
                $$result,
                {
                  href: "https://www.flyofa.com/",
                  target: "_blank"
                },
                {},
                {
                  default: () => {
                    return `Enroll Now`;
                  }
                }
              )}</div></div>`;
            },
            heading: () => {
              return `<div slot="heading" data-svelte-h="svelte-1cfsujz">12 Easy Steps to Get Started</div>`;
            }
          })}</div>`;
        },
        two: () => {
          return `<div slot="two"><div class="sections_wrapper svelte-304lf9" style="padding-top: 0;">${validate_component(CopyCard, "CopyCard").$$render($$result, {}, {}, {
            text: () => {
              return `<div slot="text" data-svelte-h="svelte-mfall">We offer the following Flight Training programs:
          <br> <br> <div class="flex-list svelte-304lf9"><ul><li>Private Pilot Ground</li> <li>Private Pilot Certificate</li> <li>Instrument Pilot Ground</li> <li>Instrument Pilot Certificate</li></ul> <ul><li>Commercial Single-Engine Land</li> <li>Commercial Multi-Engine Land Add-On</li> </ul> <ul><li>Certified Flight Instructor (CFI)</li> <li>Instrument Flight Instructor (CFI-I)</li> <li>Multi-Engine Flight Instructor (MEI)</li></ul></div></div>`;
            },
            heading: () => {
              return `<div slot="heading" data-svelte-h="svelte-10yamzz">Offered Flight Training Programs</div>`;
            }
          })}</div> <div class="sections_wrapper svelte-304lf9">${validate_component(CopyCard, "CopyCard").$$render($$result, { icon: true }, {}, {
            icon: () => {
              return `<div slot="icon">${validate_component(Update, "Update").$$render(
                $$result,
                {
                  color: "#15181C",
                  width: icon_size,
                  height: icon_size
                },
                {
                  width: ($$value) => {
                    icon_size = $$value;
                    $$settled = false;
                  },
                  height: ($$value) => {
                    icon_size = $$value;
                    $$settled = false;
                  }
                },
                {}
              )}</div>`;
            },
            text: () => {
              return `<div slot="text">If you already have a Private Pilot, Instrument Rating or FAA
          Commercial license, you can recertify yourself in as little as 3
          hours. Contact First Landings Aviation for additional details.
          <br> <br> <div class="button svelte-304lf9">${validate_component(Button, "Button").$$render($$result, { href: "/contact-us", color: "blue" }, {}, {
                default: () => {
                  return `Contact Us Now`;
                }
              })}</div></div>`;
            },
            heading: () => {
              return `<div slot="heading" data-svelte-h="svelte-1ik1lzp">Re-Current / Bi-Annual Recertification</div>`;
            }
          })}</div> <div class="sections_wrapper svelte-304lf9" style="padding-bottom: 0;">${validate_component(CopyCard, "CopyCard").$$render($$result, { icon: true }, {}, {
            icon: () => {
              return `<div slot="icon">${validate_component(CardAccountDetails, "CardAccountDetails").$$render(
                $$result,
                {
                  color: "#15181C",
                  width: icon_size,
                  height: icon_size
                },
                {
                  width: ($$value) => {
                    icon_size = $$value;
                    $$settled = false;
                  },
                  height: ($$value) => {
                    icon_size = $$value;
                    $$settled = false;
                  }
                },
                {}
              )}</div>`;
            },
            text: () => {
              return `<div slot="text">If you already have an existing foreign Private Pilot, Instrument or
          Commercial license, you can contact First Landings Aviation on how we
          can help you convert your license and either obtain a certificate of
          authenticity (FAA equivalent license), or a full FAA license.
          <br> <br> <div class="button svelte-304lf9">${validate_component(Button, "Button").$$render($$result, { href: "/contact-us", color: "blue" }, {}, {
                default: () => {
                  return `Contact Us Now`;
                }
              })}</div></div>`;
            },
            heading: () => {
              return `<div slot="heading" data-svelte-h="svelte-3i6d1n">Foreign License Conversions</div>`;
            }
          })}</div></div>`;
        },
        one: () => {
          return `<div slot="one"> <div class="sections_wrapper svelte-304lf9" style="padding-top: 0;">${validate_component(CopyCard, "CopyCard").$$render($$result, {}, {}, {
            text: () => {
              return `<div slot="text" data-svelte-h="svelte-1lmywz5">Many aspiring pilots want to learn to fly and obtain a commercial
          pilots license in the United States due to the low costs and world
          recognition of the US FAA license.
          <br> <br>
          The state of Florida is one of the best places in the US to learn to fly,
          as it is at sea level, has very mild winter weather, and students can train
          nearly every day all year.</div>`;
            },
            heading: () => {
              return `<div slot="heading" data-svelte-h="svelte-ep4293">Florida is one of the best locations for training in the US</div>`;
            }
          })}</div> <div class="sections_wrapper svelte-304lf9" style="padding-bottom: 0;">${validate_component(CopyCard, "CopyCard").$$render($$result, {}, {}, {
            text: () => {
              return `<div slot="text" data-svelte-h="svelte-7npmoj">There are many flight schools in Florida that students can choose to
          learn to fly – ranging in size from schools with 5 airplanes to
          schools with 40 plus airplanes.
          <br> <br>
          So, as a prospective student, what do we at First Landings Aviation, offer
          you that sets us apart?
          <br> <br> <ol><li><b>Longevity in Business</b> <br>
              We have been providing professional flight training since 2009.</li> <br> <li><b>Location</b> <br>
              We are located near Orlando in Central Florida at Apopka (X04), at
              an uncontrolled airfield. Other flight schools are located in large
              Class C or D airports, which may require 20 minutes-plus to taxi to
              an active runway before taking off – and then an additional 5 to 10
              minutes of flight to travel to the ‘practice area’. Our typical taxi
              time is less than 3 minutes, and our practice area is 1 minute from
              the airport.
              <br> <br>
              Why is important? In a 2 hour lesson, we spend nearly all the time
              flying, rather than 20% to 25% on the ground – this translates to approximately
              50 to 60 hours of additional flight time, which gains the student more
              flight experience.</li> <br> <li><b>Part 141 international students only need 190 hours</b> <br>
              International students can obtain their FAA commercial Single Engine
              Land in 190 hours, as compared to the typical 250 hours.</li> <br> <li><b>Modern Fleet of Aircraft</b> <br>
              First Landings has new Piper PA-28-181 Pilots 100i’s, Technically Advanced
              Aircraft (TAA), with Garmin G3X digital touch-screens and integrated
              digital avionics and autopilot, and the Tecnam P2006t multi-engine
              with duel digital G950’s and autopilots. We also have several Cessna
              172’s and Tecnam P92’s.</li> <br> <li><b>Experienced Chief Pilot and Check Pilots</b> <br>
              Our Chief Pilot has over 33,000 flight hours, and over 12,000 dual
              instruction, and all our Check Pilots have over 800 hours minimum to
              qualify.</li> <br> <li><b>Standardized Training with our Certified Flight Instructors</b> <br>
              All new instructors are required to undergo internal training to meet
              our company standards, which when coupled with our structured training
              and stage checks, results in the same standards and level of training
              from all our instructors.</li> <br> <li><b>Personalized Training Experience</b> <br>
              Our approach is to develop custom, tailored training schedules for
              each student. Everybody learns in a different way, and rather than
              a regimented linear training schedule that requires the student to
              meet all of the standards or risk failing, we strive to understand
              what the underlying issues are, and work with students to develop strategies
              to help them overcome their various training obstacles.</li> <br> <li><b>Accelerated Flight Training Program</b> <br>
              For the serious students who want to achieve their single and multi-engine
              Commercial certificate, our accelerated program can graduate students
              with no flight experience in as little 4 months.</li> <br> <li><b>Standard Flight Training Program</b> <br>
              Our standard single and multi-engine Commercial program typically graduates
              students in 6 to 8 months.</li> <br> <li><b>Cost Effective Programs</b> <br>
              All our programs include the equipment, exams, aircraft rental and
              instructor costs, and are competitively priced.</li></ol></div>`;
            },
            heading: () => {
              return `<div slot="heading" data-svelte-h="svelte-e9eynv">Why First Landings</div>`;
            }
          })}</div></div>`;
        }
      }
    )}`;
  } while (!$$settled);
  return $$rendered;
});
export {
  Page as default
};
